const checkText = (rule, value, callback) => {
  if (value == null || value == undefined || value == "") {
    return callback(new Error('请输入内容'));
  }
  if (value.length > rule.max) {
    return callback(new Error(rule.max + '字符以内'));
  }
  callback();
}

const checkNumber = (rule, value, callback) => {
  const reg = /^(\-|\+)?\d+(\.\d+)?$/;
  if (!reg.test(value)) {
    return callback(new Error('请输入数字'));
  }
  if (value.length > rule.max) {
    return callback(new Error(rule.max + '位以内'));
  }
  callback();
}

const checkInt = (rule, value, callback) => {
  const reg1 = /^\+?[1-9][0-9]*$/;   //验证非零的正整数
  const reg2 = /^\-[1-9][0-9]*$/;   //验证非零的负整数
  if (!reg1.test(value) && !reg2.test(value)) {
    return callback(new Error('请输入整数'));
  }
  if (value.length > rule.max) {
    return callback(new Error(rule.max + '位以内'));
  }
  callback();
}
export const rules = {
  text: [{ required: true, max: 500, validator: checkText }],  //验证非空  长度小于max
  select: [{ required: true, message: "请选择" }],
  date: [{ required: true, message: "请选择时间" }],
  textarea: [{ required: true, message: "请输入内容" }],
  checkbox: [{ type: 'array', required: true, message: '选择至少一个' }],
  number: [{ required: true, max: 11, validator: checkNumber }],  //验证非空  且为数字（正数、负数、小数、自然数） 且长度小于max
  int: [{ required: true, max: 11, validator: checkInt }],//验证非空  且为整数   长度小于max
}




// WEBPACK FOOTER //
// ./src/utils/rules.js